import React from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

export default class PorSemana extends React.Component {
    render() {
        return (
            <section clasName='divtable'>
                <div className="divrowH">
                    <p>Empleado</p>
                    <p>Faltas</p>
                </div>
                {this.props.week.employees.map((employee, key) => {
                    return <Employee employee={employee} key={key} status={this.props.status} />
                })}
            </section>
        )
    }
}

class Employee extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tableVisible: false,
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    payEmployee = (e) => {
        e.stopPropagation()
        debugger
        const batch = firebase.firestore().batch()
        const payments = firebase.firestore().collection('Asistencia')
        const asistencias = this.props.employee.asistencias
        for (let i = 0; i < asistencias.length; i++) {
            batch.update(payments.doc(asistencias[i].id), { estado: 'completado' })
        }
        batch.commit().catch(error => {
            console.log(error)
        })
    }
    renderTablaAsistencias = (activities) => {
        return (
            <>
                <div className="tabla">
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>Asistencia</th>
                            <th>Entrada</th>
                            <th>Salida</th>
                            <th>Puesto 1</th>
                            <th>Puesto 2</th>
                            <th>Horas Extra</th>
                        </tr>

                        {
                            activities.map((activity, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{activity.fecha}</td>
                                        <td>{activity.falta}</td>
                                        <td>{activity.hEntrada}</td>
                                        <td>{activity.hSalida}</td>
                                        <td>{activity.puesto1} {activity.horas1}h</td>
                                        <td>{activity.puesto2} {activity.horas2}h</td>
                                        <td>{activity.puestoE} {activity.horasE}h</td>
                                    </tr>
                                )
                            })
                        }

                    </tbody></table>
                </div>
            </>
        )
    }
    render() {
        return (
            <div className='divtable'>
                <div className='divrow' onClick={this.toggleTable}>
                    <p>{`${this.props.employee.employee}`}</p>
                    <p>{`Faltas: ${this.props.employee.totalFaltas}`}</p>
                </div>
                {
                    this.state.tableVisible
                        ? this.props.employee.activities.length > 0
                            ? this.renderTablaAsistencias(this.props.employee.activities)
                            : null
                        : null
                }
            </div>
        )
    }
}